export default __webpack_public_path__ + "static/media/Dark-pen.6f1ee751.svg";